import {
    StyleSheet
} from "react-native";
import type {
    NavigationMenuDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    root: {
        flexDirection: "row",
        alignItems: "center",
        minWidth: 0
    },
    list: {
        flexDirection: "row",
        alignItems: "center",
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: NavigationMenuDynamicStyleType) => {
    return {
        list: {
            gap: spaces.spacingXxs
        }
    };
};
export default stylesheet;
